import { render, staticRenderFns } from "./BasePhoneInput.vue?vue&type=template&id=1cf6f380"
import script from "./BasePhoneInput.vue?vue&type=script&lang=js"
export * from "./BasePhoneInput.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneInput.vue?vue&type=style&index=0&id=1cf6f380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports